import { gql } from '@apollo/client';
import { AI_AGENT_FIELDS } from './query.graphql';

export const CURSOR_ASSIGN_CHANNELS_V2 = gql`
  query AssignChannelsV2(
    $cursor: String
    $direction: CursorDirectionEnum
    $order: String
    $limit: Int
    $query: String
    $sort: SortEnum
  ) {
    assignChannelsV2(cursor: $cursor, direction: $direction, limit: $limit, order: $order, query: $query, sort: $sort) {
      message
      data {
        id
        channel {
          id
          friendlyName
          muted
          isAiIntegrated
          country {
            id
            name
            flag
          }
          channelGroup {
            id
            callSetting {
              id
              friendlyName
            }
          }
          phoneNumber
          unreadCounter
          v2MigratedAt
        }
        pinned
        isDefault
        updatedAt
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const QUERY_GET_NOTIFICATIONS = gql`
  query GetAllNotificationV2($sort: SortEnum, $cursor: String, $direction: CursorDirectionEnum) {
    getAllNotificationV2(sort: $sort, cursor: $cursor, direction: $direction) {
      data {
        id
        createdAt
        updatedAt
        imageUrl
        title
        body
        isExternal
        type
        redirection {
          key
          params {
            memberId
            channelId
            clientId
            clientName
            markAsClosed
            pinned
          }
        }
        replacementAttributes {
          key
          value
        }
        redirectUrl
        seenAt
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const QUERY_CHANNELSV2 = gql`
  query ChannelsV2(
    $cursor: String
    $sort: SortEnum
    $query: String
    $direction: CursorDirectionEnum
    $limit: Int
    $order: String
    $countryIds: [Int]
    $numberTypes: [String]
  ) {
    channelsV2(
      cursor: $cursor
      sort: $sort
      query: $query
      direction: $direction
      limit: $limit
      order: $order
      countryIds: $countryIds
      numberTypes: $numberTypes
    ) {
      message
      data {
        id
        friendlyName
        phoneNumber
        identity
        emergencyStatus
        beta
        isAssigned
        country {
          id
          flag
        }
        channelGroup {
          id
          name
          callSetting {
            id
            businessHourType
            metrics {
              key
              value
            }
            friendlyName
            recording
            incomingTimeout
            callerId {
              id
              friendlyName
              phoneNumber
            }
          }
        }
        assignedUsers {
          name
          id
          profilePicture {
            id
            url
          }
        }
        capability {
          fax
          mms
          sms
          voice
        }
        subscription {
          nextBillingAt
        }
        channelUserWorkspaces {
          id
          userWorkspace {
            id
            user {
              id
              name
              profilePicture {
                id
                url
                originalname
                size
                key
                mimetype
              }
            }
            status
          }
        }
        numberType
        createdAt
        metrics {
          key
          value
        }
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const QUERY_INPROCESS_PHONENUMBERS = gql`
  query InProcessPhoneNumbersV2(
    $cursor: String
    $query: String
    $limit: Int
    $direction: CursorDirectionEnum
    $sort: SortEnum
    $order: String
  ) {
    inProcessPhoneNumbersV2(
      cursor: $cursor
      query: $query
      limit: $limit
      direction: $direction
      sort: $sort
      order: $order
    ) {
      message
      data {
        id
        phoneNumber
        friendlyName
        status
        source
        numberType
        capabilities {
          voice
          SMS
          MMS
        }
        country {
          id
          name
          slug
          dialingCode
          alphaTwoCode
          alphaThreeCode
          numeric
          flag
        }
        createdAt
        updatedAt
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;
export const QUERY_FAILED = gql`
  query PurchaseFailedPhoneNumbers(
    $cursor: String
    $direction: CursorDirectionEnum
    $limit: Int
    $query: String
    $order: String
    $sort: SortEnum
  ) {
    purchaseFailedPhoneNumbers(
      cursor: $cursor
      direction: $direction
      limit: $limit
      query: $query
      order: $order
      sort: $sort
    ) {
      message
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      data {
        id
        meta {
          addressRequirements
          isoCountry
          phoneNumber
          friendlyName
          region
          rateCenter
          capabilities {
            voice
            SMS
            MMS
          }
          numberType
          basePrice
          currentPrice
          supportingDocument
          endUser
          beta
        }
        status
        workspace {
          id
          secret
          label
          isCurrent
          providerAccount {
            sid
            status
            systemSuspend
          }
          workspaceDetails {
            id
            name
            socialUrl
            noOfEmployees
            accountType
            address {
              id
              street
              suburb
              state
              country
              street2
              zipcode
            }
            planPrice {
              id
              amount
              periodicity
              isPublished
              plan {
                id
                label
                name
                slug
                shortDescription
                description
                features
                recommendation
                showAmount
                referencePlan {
                  id
                  label
                  name
                  slug
                  shortDescription
                  description
                  features
                  recommendation
                  showAmount
                }
              }
              position
              rank
            }
            documents {
              id
              url
              originalname
              size
              key
              mimetype
              createdAt
            }
            useCases {
              value
            }
          }
          status
          hasCompleted
          logo {
            id
            url
            originalname
            size
            key
            mimetype
            createdAt
          }
          active
          owner {
            id
            name
            email
            phoneNumber
            profilePicture {
              id
              url
              originalname
              size
              key
              mimetype
              createdAt
            }
            roles {
              id
              label
              slug
              level
              isActive
              isDefault
              position
              roleMaps {
                id
                isDefault
                isPublished
                isActive
                screen {
                  id
                  name
                  slug
                  isDefault
                  isActive
                  description
                }
                privilege {
                  id
                  name
                  slug
                  isDefault
                }
              }
            }
            address
            dueIn
            accountStatus
            timezone
            averageRiskScore
            totalMonthlyFee
            workspaces {
              id
              secret
              label
              isCurrent
              status
              hasCompleted
              active
              totalPhoneNumbers
              numberOfUsers
              timezone
              createdAt
              unreadCountWorkspace
              salesDealCreatedAt
              salesDealCreatedById
              pkReference
              timezoneId
              kycVerified
              trusted
            }
            language
            emailVerifiedAt
          }
          totalPhoneNumbers
          numberOfUsers
          incomingPhoneNumbers {
            _id
            providerNumber {
              addressRequirements
              isoCountry
              phoneNumber
              friendlyName
              region
              rateCenter
              numberType
              basePrice
              currentPrice
              supportingDocument
              endUser
              beta
            }
            status
            createdAt
            updatedAt
          }
          phoneNumbers {
            id
            status
            createdAt
            updatedAt
          }
          timezone
          riskScore {
            id
            documentVerificationScore
            userNumberRatioScore
            usernameCardNameScore
            countryLocationScore
            signupCardLocationScore
            referralScore
            incorporationDateScore
            totalScore
          }
          subscription {
            name
            dueIn
            monthlyFees
            billingCycleDate
            status
            transactionDate
            canceledReason
            canceledAt
            cancelScheduledAt
          }
          channels {
            id
            friendlyName
            phoneNumber
            identity
            channelUserWorkspaces {
              id
              userWorkspace {
                id
                status
                identity
              }
              channel {
                id
                friendlyName
                phoneNumber
                identity
                numberType
                purchaseAt
                releasedAt
                createdAt
                updatedAt
                numberState
                a2pVerified
                unreadCountChannel
                emergencyStatus
                beta
                isFree
                unreadCounter
              }
              isDefault
            }
            numberType
            setting {
              id
              recording
              welcomeMessage
              welcomeMessageSay {
                message
                attributes {
                  language
                  voice
                }
              }
              welcomeMessageLoop
              voicemail
              voicemailSay {
                message
              }
              voicemailLoop
              welcomeMessagePlay {
                id
                url
                originalname
                size
                key
                mimetype
                createdAt
              }
              voicemailPlay {
                id
                url
                originalname
                size
                key
                mimetype
                createdAt
              }
              caller {
                id
                friendlyName
                phoneNumber
                sid
                createdAt
                updatedAt
              }
              autoTranscribe
              forwardToExternalNumber
              forwardToExternalNumberPlay {
                id
                url
                originalname
                size
                key
                mimetype
                createdAt
              }
              forwardToExternalNumberSay {
                message
              }
              forwardToExternalNumberLoop
              externalNumber {
                externalNumber
              }
              enableVoiceMailEmail
            }
            purchaseAt
            releasedAt
            createdAt
            updatedAt
            capability {
              fax
              mms
              sms
              voice
            }
            numberState
            a2pVerified
            unreadCountChannel
            emergencyStatus
            beta
            integrationChannels {
              id
              memberCount
              integrationUserId
              workspaceId
              isEnabled
            }
            isFree
            assignedUsers {
              id
              name
              email
              phoneNumber
              address
              dueIn
              accountStatus
              timezone
              averageRiskScore
              totalMonthlyFee
              language
              emailVerifiedAt
            }
            unreadCounter
          }
          createdAt
          unreadCountWorkspace
          salesDealCreatedAt
          salesDealCreatedById
          salesDealCreatedBy {
            id
            name
            email
            phoneNumber
            address
            dueIn
            accountStatus
            timezone
            averageRiskScore
            totalMonthlyFee
            language
            emailVerifiedAt
          }
          pkReference
          timezoneId
          kycVerified
          trusted
          currentUserWorkspace {
            id
            status
            identity
          }
        }
        purchaseBy {
          id
          status
          userOnlineManagement {
            isActive
            lastSeenAt
            activeStatus
            awayTill
            message
            awaySet
            icon
          }
          user {
            id
            name
            email
            phoneNumber
            address
            dueIn
            accountStatus
            timezone
            averageRiskScore
            totalMonthlyFee
            language
            emailVerifiedAt
          }
          userWorkspaceRoles {
            role {
              id
              label
              slug
              level
              isActive
              isDefault
              position
            }
          }
          identity
        }
        country {
          id
          name
          slug
          dialingCode
          alphaTwoCode
          alphaThreeCode
          numeric
          flag
        }
        createdAt
        updatedAt
      }
    }
  }
`;

export const CURSOR_RECENT_MESSAGE = gql`
  query RecentMessageConversationsV2(
    $channelId: Int!
    $query: String
    $sort: SortEnum
    $direction: CursorDirectionEnum
    $cursor: String
    $limit: Int
    $markAsClosed: Boolean
    $conversationStatus: [String]
    $messageDirection: DirectionTypeEnum
    $voicemail: Boolean
    $scheduleMessage: Boolean
    $unread: Boolean
  ) {
    recentMessageConversationsV2(
      channelId: $channelId
      query: $query
      sort: $sort
      direction: $direction
      cursor: $cursor
      limit: $limit
      markAsClosed: $markAsClosed
      conversationStatus: $conversationStatus
      messageDirection: $messageDirection
      voicemail: $voicemail
      scheduleMessage: $scheduleMessage
      unread: $unread
    ) {
      cursor {
        endCursor
        hasNextPage
        startCursor
        hasPreviousPage
      }
      data {
        id
        updatedAt
        unreadCounter
        lastReadCursor
        pinned
        channel {
          id
        }
        client {
          id
          name
          phoneNumber
          isBlocked
          country {
            id
            flag
          }
          profilePicture {
            id
            url
          }
        }
        markAsClosed
        messageConversation {
          numMedia
          conversationType
          conversationStatus
          direction
          messageContent
          pinned
          voicemailRecordingUrl
          forwardedTo {
            id
            externalNumber
            channel {
              id
              friendlyName
              phoneNumber
            }
          }
        }
        draft {
          mediaCount
          messageContent
        }
        hasScheduledMessages
      }
    }
  }
`;

// IMPORTANT
// WHEN CHANGING KEY HERE,
// ALSO CHANGE IN
// src/graphql/cache/cache-mutations.ts L:81 (NEW_MESSAGE_FRAGMENT)
// src/graphql/cache/cache-create-objects.ts L:11 (createSurrogateMessage)
// src/graphql/mutation.graphql.ts L:219 (SEND_MESSAGE)
// src/graphql/subscription.graphql.ts L:3 (CONVERSATION_SUBSCRIPTION)
export const CURSOR_MESSAGES = gql`
  query MessageConversationsV2(
    $cursor: String
    $withCursor: Boolean
    $direction: CursorDirectionEnum
    $limit: Int
    $sort: SortEnum
    $order: String
    $clientId: Int!
    $channelId: Int!
  ) {
    messageConversationsV2(
      cursor: $cursor
      withCursor: $withCursor
      direction: $direction
      limit: $limit
      order: $order
      sort: $sort
      clientId: $clientId
      channelId: $channelId
    ) {
      message
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      data {
        id
        messageContent
        markAsClosed
        direction
        durationConference {
          endDate
          startDate
        }
        user {
          name
          isAiAgent
        }
        client {
          id
          name
          phoneNumber
          country {
            id
            flag
          }
          profilePicture {
            id
            url
          }
        }
        agent {
          callPlatform
          user {
            id
            name
            profilePicture {
              id
              url
            }
          }
          userOnlineManagement {
            isActive
          }
        }
        pinned
        conversationStatus
        conversationType
        recordingUrl
        numMedia
        friendlyName
        voicemailRecordingUrl
        createdAt
        forwardedAt
        forwardedTo {
          id
          externalNumber
          channel {
            id
            friendlyName
            phoneNumber
          }
        }
        messageConversationErrorLog {
          message
          code
          statusCode
        }
        callRecording {
          id
          url
          transcription {
            id
            jobStatus
          }
        }
        voicemailRecording {
          id
          url
          transcription {
            id
            jobStatus
          }
        }
        markAsBlocked
      }
    }
  }
`;

export const CURSOR_CANNED_RESPONSES = gql`
  query CannedResponsesV2(
    $query: String
    $cursor: String
    $direction: CursorDirectionEnum
    $limit: Int
    $order: String
    $sort: SortEnum
  ) {
    cannedResponsesV2(
      query: $query
      cursor: $cursor
      direction: $direction
      limit: $limit
      order: $order
      sort: $sort
    ) {
      message
      data {
        id
        title
        command
        content
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const CURSOR_SETTING_CANNED_RESPONSES = gql`
  query SettingCannedResponsesV2(
    $cursor: String
    $direction: CursorDirectionEnum
    $withCursor: Boolean
    $limit: Int
    $order: String
    $sort: SortEnum
    $query: String
  ) {
    cannedResponsesV2(
      cursor: $cursor
      direction: $direction
      withCursor: $withCursor
      limit: $limit
      order: $order
      sort: $sort
      query: $query
    ) {
      message
      data {
        id
        title
        command
        content
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const CURSOR_SETTING_BLOCKED_CONTACTS = gql`
  query GetBlockedContactsV2(
    $cursor: String
    $direction: CursorDirectionEnum
    $withCursor: Boolean
    $limit: Int
    $order: String
    $sort: SortEnum
    $query: String
  ) {
    getBlockedContactsV2(
      cursor: $cursor
      direction: $direction
      withCursor: $withCursor
      limit: $limit
      order: $order
      sort: $sort
      query: $query
    ) {
      message
      data {
        profilePicture {
          id
          url
        }
        country {
          id
          flag
        }
        blockedBy {
          name
        }
        blockedOn
        timeZone
        blockReason
        id
        phoneNumber
        name
        isBlocked
        isPublished
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const CURSOR_CONTACT_NOTES = gql`
  query ContactNotesV2(
    $direction: CursorDirectionEnum
    $cursor: String
    $limit: Int
    $order: String
    $sort: SortEnum
    $contactId: Int
  ) {
    contactNotesV2(
      direction: $direction
      cursor: $cursor
      limit: $limit
      order: $order
      sort: $sort
      contactId: $contactId
    ) {
      message
      data {
        updatedBy {
          id
          user {
            profilePicture {
              id
              url
              originalname
            }
            id
            name
            phoneNumber
          }
        }
        id
        description
        createdAt
        updatedAt
        createdById
      }
      cursor {
        startCursor
        hasPreviousPage
        hasNextPage
        endCursor
      }
    }
  }
`;

export const CURSOR_CONTACT_TAGS = gql`
  query ContactTagsV2(
    $cursor: String
    $direction: CursorDirectionEnum
    $limit: Int
    $order: String
    $sort: SortEnum
    $contactId: Int
  ) {
    contactTagsV2(
      cursor: $cursor
      direction: $direction
      limit: $limit
      order: $order
      sort: $sort
      contactId: $contactId
    ) {
      message
      data {
        tags {
          id
          color
          label
          slug
          type
        }
        id
        contact {
          id
        }
      }
    }
  }
`;

export const CURSOR_TAG_V2 = gql`
  query TagsV2(
    $cursor: String
    $direction: CursorDirectionEnum
    $withCursor: Boolean
    $limit: Int
    $order: String
    $sort: SortEnum
    $fields: [String]
    $query: String
  ) {
    tagsV2(
      cursor: $cursor
      direction: $direction
      withCursor: $withCursor
      limit: $limit
      order: $order
      sort: $sort
      fields: $fields
      query: $query
    ) {
      message
      data {
        id
        label
        color
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;
export const CURSOR_TEAMS_V2 = gql`
  query TeamsV2(
    $sort: SortEnum
    $cursor: String
    $limit: Int
    $query: String
    $direction: CursorDirectionEnum
    $order: String
  ) {
    teamsV2(sort: $sort, cursor: $cursor, limit: $limit, query: $query, direction: $direction, order: $order) {
      message
      data {
        totalMembers
        name
        status
        workspacesId
        metrics {
          key
          value
        }
        createdBy
        updatedBy
        description
        id
        members {
          id
          name
          profilePicture {
            id
            url
          }
          accountStatus
        }
      }
      cursor {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;
export const CURSOR_WORKSPACE_MEMBERS_V2 = gql`
  query WorkspaceMembersV2(
    $cursor: String
    $direction: CursorDirectionEnum
    $withCursor: Boolean
    $limit: Int
    $order: String
    $sort: SortEnum
    $status: UserWorkspaceStatusEnum
    $query: String
    $role: RoleEnum
    $teams: [String]
  ) {
    workspaceMembersV2(
      cursor: $cursor
      direction: $direction
      withCursor: $withCursor
      limit: $limit
      order: $order
      sort: $sort
      status: $status
      query: $query
      role: $role
      teams: $teams
    ) {
      message
      data {
        id
        status
        roles {
          label
          isDefault
          isActive
        }
        userOnlineManagement {
          icon
          message
          awayTill
          isActive
          activeStatus
          lastSeenAt
        }
        user {
          id
          name
          email
          isAiAgent
          phoneNumber
          profilePicture {
            id
            url
          }
          accountStatus
        }
        identity
        channels {
          id
          phoneNumber
        }
        metrics {
          key
          value
        }
        metrics {
          key
          value
        }
        unreadCounter
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const CURSOR_CALLER_IDS_V2 = gql`
  query CallerIdsV2(
    $cursor: String
    $direction: CursorDirectionEnum
    $withCursor: Boolean
    $limit: Int
    $order: String
    $sort: SortEnum
    $query: String
  ) {
    callerIdsV2(
      cursor: $cursor
      direction: $direction
      withCursor: $withCursor
      limit: $limit
      order: $order
      sort: $sort
      query: $query
    ) {
      message
      data {
        id
        friendlyName
        phoneNumber
        sid
        createdAt
        updatedAt
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const CURSOR_ALL_COUNTRIES = gql`
  query FetchAllCountries(
    $query: String
    $sort: SortEnum
    $order: String
    $direction: CursorDirectionEnum
    $limit: Int
    $cursor: String
  ) {
    fetchAllCountries(
      query: $query
      sort: $sort
      order: $order
      direction: $direction
      limit: $limit
      cursor: $cursor
    ) {
      message
      data {
        id
        name
        slug
        dialingCode
        alphaTwoCode
        alphaThreeCode
        numeric
        flag
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const CURSOR_CONTACTS_LIST = gql`
  query ContactsV2(
    $cursor: String
    $direction: CursorDirectionEnum
    $limit: Int
    $sort: SortEnum
    $query: String
    $order: String
    $sourceType: [ContactSourceTypeEnum]
    $countryCode: [String]
    $excludeCountryCode: [String]
    $tags: [Int]
    $nameStartsWith: String
    $fields: [String]
  ) {
    contactsV2(
      cursor: $cursor
      direction: $direction
      limit: $limit
      sort: $sort
      query: $query
      order: $order
      sourceType: $sourceType
      countryCode: $countryCode
      excludeCountryCode: $excludeCountryCode
      tags: $tags
      nameStartsWith: $nameStartsWith
      fields: $fields
    ) {
      message
      data {
        id
        name
        email
        phoneNumber
        country {
          id
          flag
        }
        metrics {
          key
          value
        }
        tags {
          id
          label
          color
        }
        profilePicture {
          id
          url
        }
        sourceType
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const CURSOR_PINNED_MESSAGES = gql`
  query ListPinnedMessageConversationsV2($clientId: Int!, $channelId: Int!, $sort: SortEnum, $order: String) {
    listPinnedMessageConversationsV2(clientId: $clientId, channelId: $channelId, sort: $sort, order: $order) {
      message
      data {
        id
        direction
        numMedia
        client {
          id
          name
          phoneNumber
          profilePicture {
            id
            url
          }
        }
        pinned
        conversationStatus
        messageContent
        markAsClosed
        conversationType
        agent {
          id
          user {
            id
            name
            phoneNumber
            profilePicture {
              id
              url
            }
          }
        }
        createdAt
        recording {
          id
          url
        }
        cursor
        voicemailRecording {
          id
          url
        }
        callRecording {
          id
          url
        }
      }
    }
  }
`;

export const FORWARDED_SOURCE_FIELDS = gql`
  fragment ForwardedSourceFields on ForwardedSource {
    sourceType
    body
    createdAt
    sourceMessageId
    channelConversation {
      contactLabel
      channelLabel
      channelId
      clientId
      conversationRef
      numMedia
      canOpen
    }
    memberChat {
      isDeleted
      memberId
      roomType
      chatAttachments {
        id
        key
        mimetype
        originalname
        size
        createdAt
      }
      originalSender {
        id
        user {
          id
          name
        }
      }
    }
  }
`;

export const CURSOR_MEMBER_MESSAGES = gql`
  query GetChatMessagesV2(
    $roomId: Int!
    $cursor: String
    $direction: CursorDirectionEnum
    $withCursor: Boolean
    $limit: Int
    $order: String
    $sort: SortEnum
  ) {
    getChatMessagesV2(
      roomId: $roomId
      cursor: $cursor
      direction: $direction
      withCursor: $withCursor
      limit: $limit
      order: $order
      sort: $sort
    ) {
      message
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      data {
        id
        body
        metadata
        createdAt
        isPinned
        isDeleted
        deliveryStatus
        reactions {
          emoji
          count
          userWorkspaceIds
        }
        chatAttachments {
          id
          key
          mimetype
          originalname
          size
          createdAt
        }
        repliedTo {
          id
          body
          isDeleted
          senderId
          senderName
          chatAttachments {
            id
            key
            mimetype
            originalname
            size
            createdAt
          }
        }
        type
        forwardedSource {
          ...ForwardedSourceFields
        }
        messageConversation {
          id
          conversationStatus
          effectiveStartedAt
          effectiveEndedAt
        }
        sender {
          id
          status
          userOnlineManagement {
            isActive
            lastSeenAt
            activeStatus
            awayTill
            message
            icon
          }
          user {
            id
            name
            email
            phoneNumber
            profilePicture {
              id
              url
            }
          }
        }
      }
    }
  }
  ${FORWARDED_SOURCE_FIELDS}
`;

export const CURSOR_PINNED_MEMBER_MESSAGES = gql`
  query ListPinnedChatMessages($roomId: Int!, $order: String, $sort: SortEnum) {
    listPinnedChatMessages(roomId: $roomId, order: $order, sort: $sort) {
      message
      data {
        id
        isPinned
        cursor
        createdAt
        body
        type
        numMedia
        forwardedSource {
          ...ForwardedSourceFields
        }
        sender {
          id
          user {
            name
            profilePicture {
              url
            }
            id
            phoneNumber
          }
        }
      }
    }
  }
  ${FORWARDED_SOURCE_FIELDS}
`;

export const CURSOR_CHANNEL_CONVERSATIONS = gql`
  query ChannelConversations(
    $clientId: String!
    $cursor: String
    $direction: CursorDirectionEnum
    $withCursor: Boolean
    $limit: Int
    $sort: SortEnum
    $query: String
    $countryId: String
    $order: String
  ) {
    channelConversations(
      clientId: $clientId
      cursor: $cursor
      direction: $direction
      withCursor: $withCursor
      limit: $limit
      sort: $sort
      query: $query
      countryId: $countryId
      order: $order
    ) {
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      data {
        id
        createdAt
        updatedAt
        channel {
          id
          friendlyName
          country {
            name
            flag
          }
          phoneNumber
          unreadCounter
        }
        messageConversation {
          messageContent
          direction
          id
          numMedia
          conversationStatus
          conversationType
          friendlyName
        }
        isDefault
      }
    }
  }
`;

export const CURSOR_NEW_CHANNEL_CONVERSATIONS = gql`
  query ChannelsForNewConversations(
    $clientId: String!
    $cursor: String
    $direction: CursorDirectionEnum
    $withCursor: Boolean
    $limit: Int
    $order: String
    $sort: SortEnum
    $countryId: String
    $query: String
  ) {
    channelsForNewConversations(
      clientId: $clientId
      cursor: $cursor
      direction: $direction
      withCursor: $withCursor
      limit: $limit
      order: $order
      sort: $sort
      countryId: $countryId
      query: $query
    ) {
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      data {
        id
        isDefault
        channel {
          id
          phoneNumber
          friendlyName
          country {
            alphaTwoCode
            flag
            id
            name
          }
        }
      }
    }
  }
`;

export const CURSOR_INTEGRATIONS = gql`
  query IntegrationsV2(
    $sort: SortEnum
    $cursor: String
    $withCursor: Boolean
    $limit: Int
    $query: String
    $direction: CursorDirectionEnum
    $order: String
    $includeInactive: Boolean!
  ) {
    integrationsV2(
      sort: $sort
      cursor: $cursor
      withCursor: $withCursor
      limit: $limit
      query: $query
      direction: $direction
      order: $order
      includeInactive: $includeInactive
    ) {
      message
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      data {
        id
        name
        logoUrl
        label
        domain
        description
        integrationUser {
          id
          status
        }
      }
    }
  }
`;

export const CURSOR_INTEGRATION_CHANNELS = gql`
  query IntegrationChannelsV2(
    $sort: SortEnum
    $cursor: String
    $withCursor: Boolean
    $limit: Int
    $query: String
    $direction: CursorDirectionEnum
    $order: String
    $integrationUserId: Int!
    $countryCode: [String]
  ) {
    integrationChannelsV2(
      sort: $sort
      cursor: $cursor
      withCursor: $withCursor
      limit: $limit
      query: $query
      direction: $direction
      order: $order
      integrationUserId: $integrationUserId
      countryCode: $countryCode
    ) {
      message
      cursor {
        startCursor
        hasPreviousPage
        hasNextPage
        endCursor
      }
      data {
        id
        friendlyName
        phoneNumber
        country {
          id
          flag
        }
        integrationChannels {
          id
          integrationUserId
          isEnabled
        }
      }
    }
  }
`;

export const CURSOR_GET_TIMEZONES = gql`
  query AttributeValuesV2(
    $sort: SortEnum
    $cursor: String
    $withCursor: Boolean
    $limit: Int
    $query: String
    $direction: CursorDirectionEnum
    $order: String
    $attributeName: String
  ) {
    attributeValuesV2(
      sort: $sort
      cursor: $cursor
      withCursor: $withCursor
      limit: $limit
      query: $query
      direction: $direction
      order: $order
      attributeName: $attributeName
    ) {
      message
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      data {
        id
        value
        description
        isActive
        isDefault
        attributeId
        label
      }
    }
  }
`;

export const CURSOR_AVAILABLE_PHONE_NUMBERS_V2 = gql`
  query AvailablePhoneNumbersV2(
    $countryCode: String!
    $cursor: String
    $limit: Int
    $numberType: NumberTypeEnum
    $smsEnabled: Boolean
    $voiceEnabled: Boolean
    $mmsEnabled: Boolean
    $faxEnabled: Boolean
    $excludeAllAddressRequired: Boolean
    $excludeLocalAddressRequired: Boolean
    $excludeForeignAddressRequired: Boolean
    $beta: Boolean
    $contains: String
    $areaCode: Int
    $inLocality: String
  ) {
    availablePhoneNumbersV2(
      countryCode: $countryCode
      cursor: $cursor
      limit: $limit
      numberType: $numberType
      smsEnabled: $smsEnabled
      voiceEnabled: $voiceEnabled
      mmsEnabled: $mmsEnabled
      faxEnabled: $faxEnabled
      excludeAllAddressRequired: $excludeAllAddressRequired
      excludeLocalAddressRequired: $excludeLocalAddressRequired
      excludeForeignAddressRequired: $excludeForeignAddressRequired
      beta: $beta
      contains: $contains
      areaCode: $areaCode
      inLocality: $inLocality
    ) {
      message
      data {
        addressRequirements
        isoCountry
        phoneNumber
        friendlyName
        region
        rateCenter
        capabilities {
          voice
          SMS
          MMS
        }
        numberType
        basePrice
        currentPrice
        supportingDocument
        endUser
        beta
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const CURSOR_AREA_CODES = gql`
  query AreaCodes(
    $direction: CursorDirectionEnum
    $cursor: String
    $withCursor: Boolean
    $limit: Int
    $order: String
    $sort: SortEnum
    $fields: [String]
    $query: String
    $alphaTwoCode: String
  ) {
    areaCodes(
      cursor: $cursor
      direction: $direction
      withCursor: $withCursor
      limit: $limit
      order: $order
      sort: $sort
      fields: $fields
      query: $query
      alphaTwoCode: $alphaTwoCode
    ) {
      message
      data {
        id
        name
        slug
        code
        stateId
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const CURSOR_IVR_MENU_OPTIONS_CALL_SETTINGS = gql`
  query GetIvrMenuOptionsInCallSetting(
    $callSettingId: Int!
    $cursor: String
    $direction: CursorDirectionEnum
    $limit: Int
    $order: String
    $sort: SortEnum
  ) {
    getIvrMenuOptionsInCallSetting(
      callSettingId: $callSettingId
      cursor: $cursor
      direction: $direction
      limit: $limit
      order: $order
      sort: $sort
    ) {
      data {
        input
        ifUnansweredRedirectTo
        id
        callIvrConditionTarget {
          target {
            id
            name
          }
          id
        }
        action
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const CURSOR_IVR_MENU_OPTIONS_CHANNEL_SETTINGS = gql`
  query GetIvrMenuOptionsInChannelSetting(
    $channelId: Int!
    $cursor: String
    $direction: CursorDirectionEnum
    $withCursor: Boolean
    $limit: Int
    $order: String
    $sort: SortEnum
  ) {
    getIvrMenuOptionsInChannelSetting(
      channelId: $channelId
      cursor: $cursor
      direction: $direction
      withCursor: $withCursor
      limit: $limit
      order: $order
      sort: $sort
    ) {
      message
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      data {
        id
        input
        action
        ifUnansweredRedirectTo
        callIvrConditionTarget {
          id
          target {
            id
            name
          }
        }
      }
    }
  }
`;

export const CURSOR_MESSAGE_SCHEDULES = gql`
  query MessageSchedules(
    $cursor: String
    $limit: Int
    $order: String
    $sort: SortEnum
    $channelId: Int!
    $clientId: Int!
    $status: [MessageScheduleStatusEnum]
  ) {
    messageSchedules(
      cursor: $cursor
      limit: $limit
      order: $order
      sort: $sort
      channelId: $channelId
      clientId: $clientId
      status: $status
    ) {
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      data {
        scheduleAt
        messageContent
        id
        createdAt
        attachments {
          id
          url
          mimetype
        }
        client {
          id
          name
          profilePicture {
            id
            url
          }
          country {
            flag
            id
          }
        }
        channel {
          id
        }
        failureReason
        status
      }
    }
  }
`;
export const CUROSR_GET_CALL_SETTINGS = gql`
  query GetCallSettings($sort: SortEnum, $cursor: String, $limit: Int, $query: String, $order: String) {
    getCallSettings(sort: $sort, cursor: $cursor, limit: $limit, query: $query, order: $order) {
      message
      data {
        updatedAt
        recording
        metrics {
          value
          key
        }
        id
        friendlyName
        createdAt
        channelGroups {
          slug
          name
          id
        }
        businessHourType
        channels {
          phoneNumber
          friendlyName
          assignedUsers {
            name
            profilePicture {
              url
              id
            }
          }
        }
        callerId {
          phoneNumber
          friendlyName
          id
        }
      }
      cursor {
        startCursor
        hasPreviousPage
        hasNextPage
        endCursor
      }
    }
  }
`;

export const CURSOR_GET_CHANNEL_GROUP_IN_CALL_SETTING = gql`
  query GetChannelGroupsInCallSetting(
    $callSettingId: Int!
    $sort: SortEnum
    $cursor: String
    $limit: Int
    $order: String
    $query: String
    $onlyAssignedGroups: Boolean
  ) {
    getChannelGroupsInCallSetting(
      callSettingId: $callSettingId
      sort: $sort
      cursor: $cursor
      limit: $limit
      order: $order
      query: $query
      onlyAssignedGroups: $onlyAssignedGroups
    ) {
      message
      cursor {
        startCursor
        hasPreviousPage
        hasNextPage
        endCursor
      }
      data {
        name
        metrics {
          value
          key
        }
        id
        callSettingId
      }
    }
  }
`;

export const CURSOR_GET_COMPLIANCE_CAMPAIGNS = gql`
  query GetComplianceCampaigns(
    $cursor: String
    $query: String
    $limit: Int
    $direction: CursorDirectionEnum
    $withCursor: Boolean
    $order: String
    $sort: SortEnum
  ) {
    getComplianceCampaigns(
      cursor: $cursor
      query: $query
      limit: $limit
      direction: $direction
      withCursor: $withCursor
      order: $order
      sort: $sort
    ) {
      message
      data {
        id
        name
        type
        createdAt
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const CURSOR_GET_CONTACT_COMPLIANCE_CONSENTS = gql`
  query ContactComplianceConsents(
    $cursor: String
    $direction: CursorDirectionEnum
    $withCursor: Boolean
    $limit: Int
    $order: String
    $sort: SortEnum
    $fields: [String]
    $query: String
    $campaigns: [ComplianceCampaignFilter]
  ) {
    contactComplianceConsents(
      cursor: $cursor
      direction: $direction
      withCursor: $withCursor
      limit: $limit
      order: $order
      sort: $sort
      fields: $fields
      query: $query
      campaigns: $campaigns
    ) {
      message
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      data {
        id
        profilePicture {
          id
          url
        }
        phoneNumber
        contactComplianceConsents {
          id
          isConsented
          flowDetails
          consentedAt
          consentSource
          consentDetails
          campaign {
            id
            messageServiceName
          }
        }
        country {
          id
          name
          flag
          alphaTwoCode
        }
        name
      }
    }
  }
`;

export const CURSOR_CHANNEL_GROUPS = gql`
  query ChannelGroups($cursor: String, $order: String, $sort: SortEnum, $limit: Int, $query: String) {
    channelGroups(cursor: $cursor, order: $order, sort: $sort, limit: $limit, query: $query) {
      message
      data {
        name
        id
        callSetting {
          id
          friendlyName
        }
        channel {
          id
          friendlyName
          phoneNumber
        }
        metrics {
          value
          key
        }
      }
      cursor {
        startCursor
        hasPreviousPage
        hasNextPage
        endCursor
      }
    }
  }
`;

export const GET_CHANNELS_BY_GROUP = gql`
  query GetChannelByGroup(
    $groupId: Int!
    $cursor: String
    $query: String
    $limit: Int
    $sort: SortEnum
    $withCursor: Boolean
  ) {
    getChannelByGroup(
      groupId: $groupId
      cursor: $cursor
      query: $query
      limit: $limit
      sort: $sort
      withCursor: $withCursor
    ) {
      message
      cursor {
        startCursor
        hasPreviousPage
        hasNextPage
        endCursor
      }
      data {
        id
        phoneNumber
        friendlyName
        channelGroup {
          id
        }
        country {
          id
          name
          flag
        }
      }
    }
  }
`;

export const CURSOR_LIVE_CALLS = gql`
  query LiveConferencesV2(
    $cursor: String
    $direction: CursorDirectionEnum
    $withCursor: Boolean
    $limit: Int
    $order: String
    $sort: SortEnum
    $query: String
    $channelId: Int
  ) {
    liveConferencesV2(
      cursor: $cursor
      direction: $direction
      withCursor: $withCursor
      limit: $limit
      order: $order
      sort: $sort
      query: $query
      channelId: $channelId
    ) {
      message
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      data {
        id
        agent {
          user {
            name
            isAiAgent
            profilePicture {
              id
              url
            }
          }
          userOnlineManagement {
            isActive
          }
        }

        client {
          id
          name
          phoneNumber
          country {
            flag
          }
          profilePicture {
            id
            url
          }
        }
        channel {
          friendlyName
          phoneNumber
          identity
          country {
            name
            flag
          }
        }
        direction
        conversationStatus
        createdAt
        durationConference {
          startDate
        }
        supervisionId
        supervisionMode
      }
    }
  }
`;

export const CURSOR_GET_WORKSPACE_CHANNEL_MEMBERS = gql`
  query GetWorkspaceChannelMembers(
    $channelId: Int!
    $limit: Int
    $cursor: String
    $direction: CursorDirectionEnum
    $withCursor: Boolean
    $order: String
    $sort: SortEnum
    $query: String
    $assignedOnly: Boolean
  ) {
    getWorkspaceChannelMembers(
      channelId: $channelId
      limit: $limit
      cursor: $cursor
      direction: $direction
      withCursor: $withCursor
      order: $order
      sort: $sort
      query: $query
      assignedOnly: $assignedOnly
    ) {
      message
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      data {
        isAssignedToChannel
        id
        user {
          id
          name
          email
          phoneNumber
          profilePicture {
            id
            url
          }
        }
      }
    }
  }
`;

export const GET_PACKAGES = gql`
  query GetPackages(
    $cursor: String
    $direction: CursorDirectionEnum
    $limit: Int
    $sort: SortEnum
    $order: String
    $sortBy: PackageSortByEnum
    $query: String
    $type: PackageType
    $countryIds: [Int]
    $featuredPackage: Boolean
  ) {
    getPackages(
      cursor: $cursor
      direction: $direction
      limit: $limit
      sort: $sort
      order: $order
      sortBy: $sortBy
      query: $query
      type: $type
      countryIds: $countryIds
      featuredPackage: $featuredPackage
    ) {
      message
      data {
        id
        name
        type
        tierLabel
        originCountryIds
        destinationCountryIds
        badge
        badgeTone
        finalPrice
        originalPrice
        duration
        durationCycle
        featuredPackage
        features {
          id
          name
          duration
          segments
        }
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      count
    }
  }
`;
export const CURSOR_LIST_BULK_MESSAGING_CAMPAIGN = gql`
  query ListBulkMessagingCampaign(
    $cursor: String
    $query: String
    $limit: Int
    $withCursor: Boolean
    $direction: CursorDirectionEnum
    $order: String
    $sort: SortEnum
    $campaignType: BulkMessagingCampaignTypeEnum
    $status: [BulkMessagingCampaignStatusEnum]
    $createdBy: [Int]
    $initiatedFrom: Date
    $initiatedTo: Date
  ) {
    listBulkMessagingCampaign(
      cursor: $cursor
      query: $query
      limit: $limit
      withCursor: $withCursor
      direction: $direction
      order: $order
      sort: $sort
      campaignType: $campaignType
      status: $status
      createdBy: $createdBy
      initiatedFrom: $initiatedFrom
      initiatedTo: $initiatedTo
    ) {
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      data {
        id
        campaignName
        isDraft
        messageTemplate
        mediaCount
        campaignType
        messagingType
        status
        scheduleType
        isScheduled
        initiatedAt
        scheduledAt
        maxOccurrence
        endAt
        recipients {
          id
          name
          phoneNumber
          profile {
            id
            url
            originalname
            size
            key
            mimetype
            createdAt
          }
        }
        attachments {
          id
          fileName
          mimetype
          fileSize
          fileUrl
        }
        metrics {
          key
          value
        }
        createdBy {
          id
          name
          profilePicture {
            id
            url
            originalname
            size
            key
            mimetype
            createdAt
          }
          roles {
            id
            label
            slug
            level
            isActive
            isDefault
            position
          }
        }
        createdAt
        deliverySummary {
          totalSent
          totalRecipients
          runStatus
          totalDelivered
        }
      }
    }
  }
`;

export const CURSOR_INTEGRATION_TRIGGER_GROUP_CHANNELS = gql`
  query IntegrationTriggerGroupChannels(
    $integrationId: Int!
    $groupId: Int!
    $sort: SortEnum
    $cursor: String
    $withCursor: Boolean
    $limit: Int
    $query: String
    $direction: CursorDirectionEnum
    $order: String
    $countryCode: [String]
  ) {
    integrationTriggerGroupChannels(
      integrationId: $integrationId
      groupId: $groupId
      sort: $sort
      cursor: $cursor
      withCursor: $withCursor
      limit: $limit
      query: $query
      direction: $direction
      order: $order
      countryCode: $countryCode
    ) {
      message
      cursor {
        startCursor
        hasPreviousPage
        hasNextPage
        endCursor
      }
      data {
        id
        friendlyName
        phoneNumber
        country {
          id
          name
          flag
        }
        isSelected
      }
    }
  }
`;

export const CURSOR_LIST_BULK_MESSAGING_CAMPAIGN_RUNS = gql`
  query ListBulkMessagingCampaignRuns(
    $campaignId: Int!
    $cursor: String
    $direction: CursorDirectionEnum
    $withCursor: Boolean
    $limit: Int
    $order: String
    $sort: SortEnum
    $query: String
    $status: BulkMessagingRunStatusEnum
    $runControl: [BulkMessagingRunStatusEnum]
  ) {
    listBulkMessagingCampaignRuns(
      campaignId: $campaignId
      cursor: $cursor
      direction: $direction
      withCursor: $withCursor
      limit: $limit
      order: $order
      sort: $sort
      query: $query
      status: $status
      runControl: $runControl
    ) {
      message
      data {
        id
        runNumber
        status
        totalRecipients
        scheduledAt
        startedAt
        completedAt
        createdAt
        updatedAt
        initiatedAt
        campaign {
          id
          name
        }
        deliverySummary {
          totalProcessed
          totalSent
          totalFailed
          totalDelivered
        }
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const CURSOR_LIST_PAYMENT_ORDERS = gql`
  query ListPaymentOrders($lienStatus: PaymentOrderLienStatusEnum, $limit: Int, $sort: SortEnum, $order: String) {
    listPaymentOrders(lienStatus: $lienStatus, limit: $limit, sort: $sort, order: $order) {
      message
      data {
        id
        lienStatus
        createdAt
      }
      cursor {
        hasNextPage
      }
    }
  }
`;

export const QUERY_LIST_NUMBER_SUBSCRIPTION_DETAILS_FOR_DATE = gql`
  query ListNumberSubscriptionDetailsForDate(
    $nextBillingDate: Date!
    $cursor: String
    $direction: CursorDirectionEnum
    $limit: Int
    $order: String
    $sort: SortEnum
    $withCursor: Boolean
    $query: String
  ) {
    listNumberSubscriptionDetailsForDate(
      nextBillingDate: $nextBillingDate
      cursor: $cursor
      direction: $direction
      limit: $limit
      order: $order
      sort: $sort
      withCursor: $withCursor
      query: $query
    ) {
      message
      data {
        id
        phoneNumber
        plan
        country {
          flag
        }
        nextBillingDate
        amount
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const CURSOR_AI_ADVANCE_CALL_REPORT_V2 = gql`
  query AiAdvanceCallReportV2(
    $fromDate: Date!
    $toDate: Date!
    $limit: Int
    $sentimentType: String
    $reasonType: String
    $conclusionType: String
    $callType: String
    $callResolution: String
    $userWorkspaceId: Int
    $order: String
    $sort: SortEnum
    $cursor: String
    $direction: CursorDirectionEnum
    $query: String
  ) {
    aiAdvanceCallReportV2(
      fromDate: $fromDate
      toDate: $toDate
      limit: $limit
      sentimentType: $sentimentType
      reasonType: $reasonType
      conclusionType: $conclusionType
      callType: $callType
      callResolution: $callResolution
      userWorkspaceId: $userWorkspaceId
      order: $order
      sort: $sort
      cursor: $cursor
      direction: $direction
      query: $query
    ) {
      message
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      data {
        userName
        callDirection
        createdAt
        agentPhoneNumber
        callRecordingId
        transcriptionId
        callRecordingUrl
        customerName
        customerPhoneNumber
        sentiment
        reasonForCall
        callCount
      }
    }
  }
`;

export const CURSOR_AI_DASHBOARD_INTENT_V2 = gql`
  query AiDashboardIntentV2(
    $fromDate: Date!
    $toDate: Date!
    $limit: Int
    $intentType: String!
    $order: String
    $sort: SortEnum
    $cursor: String
    $direction: CursorDirectionEnum
    $withCursor: Boolean
  ) {
    aiDashboardIntentV2(
      fromDate: $fromDate
      toDate: $toDate
      limit: $limit
      intentType: $intentType
      order: $order
      sort: $sort
      cursor: $cursor
      direction: $direction
      withCursor: $withCursor
    ) {
      message
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      data {
        intent
        currentCount
        currentSentiment
        previousCount
        previousSentiment
        callVolume
      }
    }
  }
`;

export const CURSOR_AI_DASHBOARD_MEMBER_PERFORMANCE_V2 = gql`
  query AiDashboardMemberPerformanceV2(
    $sentimentType: String!
    $fromDate: Date!
    $toDate: Date!
    $limit: Int
    $order: String
    $sort: SortEnum
    $cursor: String
    $direction: CursorDirectionEnum
    $withCursor: Boolean
  ) {
    aiDashboardMemberPerformanceV2(
      sentimentType: $sentimentType
      fromDate: $fromDate
      toDate: $toDate
      limit: $limit
      order: $order
      sort: $sort
      cursor: $cursor
      direction: $direction
      withCursor: $withCursor
    ) {
      message
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      data {
        id
        userName
        percentage
        totalCallCount
        transcribeCallCount
        transcribeSpecificSentimentCount
        averageDuration
      }
    }
  }
`;

export const CURSOR_AI_AGENT_CALL_SESSIONS = gql`
  query AiAgentCallSessions(
    $aiAgentId: Int!
    $includeTestCalls: Boolean
    $cursor: String
    $direction: CursorDirectionEnum
    $withCursor: Boolean
    $order: String
    $sort: SortEnum
    $limit: Int
  ) {
    aiAgentCallSessions(
      aiAgentId: $aiAgentId
      includeTestCalls: $includeTestCalls
      cursor: $cursor
      direction: $direction
      withCursor: $withCursor
      limit: $limit
      order: $order
      sort: $sort
    ) {
      message
      data {
        id
        callerName
        callerPhoneNumber
        direction
        startedAt
        durationSeconds
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const CURSOR_AI_KNOWLEDGE_SOURCES = gql`
  query AiKnowledgeSources(
    $cursor: String
    $direction: CursorDirectionEnum
    $withCursor: Boolean
    $limit: Int
    $order: String
    $sort: SortEnum
    $query: String
  ) {
    aiKnowledgeSources(
      cursor: $cursor
      direction: $direction
      withCursor: $withCursor
      limit: $limit
      order: $order
      sort: $sort
      query: $query
    ) {
      message
      data {
        id
        name
        type
        itemCount
        promptText
        website {
          url
          depth
        }
        description
        assignedAgents {
          id
          name
        }
        createdAt
        updatedAt
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const GET_WORKSPACE_PACKAGES = gql`
  query GetWorkspacePackages(
    $cursor: String
    $direction: CursorDirectionEnum
    $limit: Int
    $sort: SortEnum
    $order: String
    $status: WorkspacePackageStatus
    $isActive: Boolean
    $query: String
  ) {
    workspacePackages(
      cursor: $cursor
      direction: $direction
      limit: $limit
      sort: $sort
      order: $order
      status: $status
      isActive: $isActive
      query: $query
    ) {
      message
      data {
        id
        packageId
        isActive
        status
        startedAt
        expiredAt
        autoRenew
        nextBillingAt
        featureUsages {
          packageFeatureId
          name
          totalUnit
          remainingUnit
          usedUnit
        }
        package {
          id
          name
          type
          tierLabel
          originCountryIds
          destinationCountryIds
          badge
          badgeTone
          finalPrice
          originalPrice
          duration
          durationCycle
          isAvailable
          features {
            id
            name
            duration
            segments
          }
        }
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      count
    }
  }
`;
export const CURSOR_BULK_IMPORT_JOB_ROWS = gql`
  query BulkImportJobRows(
    $jobId: String!
    $cursor: String
    $direction: CursorDirectionEnum
    $withCursor: Boolean
    $limit: Int
    $order: String
    $sort: SortEnum
    $query: String
    $status: BulkImportRowStatusEnum
  ) {
    bulkImportJobRows(
      jobId: $jobId
      cursor: $cursor
      direction: $direction
      withCursor: $withCursor
      limit: $limit
      order: $order
      sort: $sort
      query: $query
      status: $status
    ) {
      message
      data {
        id
        rowNumber
        status
        errorReason
        phoneNumber
        dialingCode
        name
        email
        address
        companyName
        website
        createdAt
        updatedAt
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      pagination {
        total
        success
        failed
      }
      summary {
        total
        success
        failed
      }
    }
  }
`;

export const FETCH_ALL_COUNTRIES_FOR_PACKAGES = gql`
  query FetchAllCountriesForPackages($cursor: String, $limit: Int) {
    fetchAllCountries(cursor: $cursor, limit: $limit) {
      message
      data {
        id
        name
        alphaTwoCode
        flag
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const CURSOR_RECENT_CHAT_MESSAGES = gql`
  query RecentChatMessages(
    $limit: Int
    $cursor: String
    $direction: CursorDirectionEnum
    $withCursor: Boolean
    $query: String
    $role: RoleEnum
    $teams: [String!]
    $sortBy: RecentChatMessageSortEnum
  ) {
    recentChatMessages(
      limit: $limit
      cursor: $cursor
      direction: $direction
      withCursor: $withCursor
      query: $query
      role: $role
      teams: $teams
      sortBy: $sortBy
    ) {
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      data {
        id
        lastMessageAt
        unreadCount
        lastReadCursor
        member {
          id
          name
          role
          profilePictureUrl
          isActive
          activeStatus
          lastSeenAt
        }
        room {
          id
          identity
          type
        }
        lastMessage {
          id
          body
          type
          createdAt
          senderId
          senderName
          isDeleted
          attachmentCount
          attachmentMimetype
        }
      }
    }
  }
`;

export const CURSOR_CHAT_ROOM_ATTACHMENTS = gql`
  query GetChatRoomAttachments(
    $roomId: Int!
    $limit: Int
    $cursor: String
    $direction: CursorDirectionEnum
    $withCursor: Boolean
  ) {
    getChatRoomAttachments(
      roomId: $roomId
      limit: $limit
      cursor: $cursor
      direction: $direction
      withCursor: $withCursor
    ) {
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      data {
        id
        key
        mimetype
        originalname
        size
      }
    }
  }
`;

export const CHAT_ROOM_NOTE_FIELDS = gql`
  fragment ChatRoomNoteFields on ChatRoomNote {
    id
    description
    createdAt
    updatedAt
    createdBy {
      id
      name
      profilePicture {
        id
        url
      }
    }
  }
`;

export const CURSOR_CHAT_ROOM_NOTES = gql`
  query ChatRoomNotes(
    $roomId: Int!
    $limit: Int
    $cursor: String
    $direction: CursorDirectionEnum
    $withCursor: Boolean
  ) {
    chatRoomNotes(roomId: $roomId, limit: $limit, cursor: $cursor, direction: $direction, withCursor: $withCursor) {
      message
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      data {
        ...ChatRoomNoteFields
      }
    }
  }
  ${CHAT_ROOM_NOTE_FIELDS}
`;

export const CURSOR_AI_AGENTS = gql`
  ${AI_AGENT_FIELDS}
  query AiAgents(
    $cursor: String
    $direction: CursorDirectionEnum
    $withCursor: Boolean
    $limit: Int
    $order: String
    $sort: SortEnum
    $query: String
  ) {
    aiAgents(
      cursor: $cursor
      direction: $direction
      withCursor: $withCursor
      limit: $limit
      order: $order
      sort: $sort
      query: $query
    ) {
      message
      data {
        ...AiAgentFields
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const CURSOR_CALL_QUEUE_CALLS = gql`
  query GetCallQueueCalls(
    $status: CallQueueCallStatusEnum!
    $sort: SortEnum
    $cursor: String
    $withCursor: Boolean
    $limit: Int
    $query: String
    $direction: CursorDirectionEnum
  ) {
    getCallQueueCalls(
      status: $status
      sort: $sort
      cursor: $cursor
      withCursor: $withCursor
      limit: $limit
      query: $query
      direction: $direction
    ) {
      message
      data {
        id
        callQueueId
        channelId
        friendlyName
        contactPhoneNumber
        channelPhoneNumber
        channelIdentity
        status
        enqueuedAt
        position
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const CURSOR_RECENT_CALL_LOGS = gql`
  query RecentCallLogs($channelId: Int!, $first: Int, $after: String, $sort: SortEnum, $order: String) {
    recentCallLogs(channelId: $channelId, first: $first, after: $after, sort: $sort, order: $order) {
      message
      edges {
        node {
          id
          channelId
          direction
          conversationType
          conversationStatus
          createdAt
          country {
            id
            flag
          }
          client {
            id
            name
            phoneNumber
            isPublished
            country {
              id
              flag
            }
            profilePicture {
              id
              url
            }
          }
        }
        cursor
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
        count
      }
    }
  }
`;
